import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-white pt-16 pb-8" data-id="element-99">
      <div className="container mx-auto px-4" data-id="element-100">
        <div className="grid md:grid-cols-4 gap-8 mb-12" data-id="element-101">
          <div data-id="element-102">
            <div className="flex items-center mb-6 flex-wrap" data-id="element-103">
              <span className="text-lg tracking-tight flex items-center whitespace-nowrap" data-id="element-104">
                <span className="font-bold text-white" data-id="element-105">swedenmark</span>
                <span className="mx-0.5 text-xl leading-none translate-y-[-1px] text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-red-400" data-id="element-106">
                  &bull;
                </span>
                <span className="font-semibold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-red-400" data-id="element-107">
                  studio
                </span>
              </span>
            </div>
            <p className="text-gray-400 mb-6" data-id="element-108">
              Blending precision with creativity to build exceptional digital
              experiences.
            </p>
          </div>
          <div data-id="element-109">
            <h3 className="text-lg font-semibold mb-6" data-id="element-110">Quick Links</h3>
            <ul className="space-y-3" data-id="element-111">
              <li data-id="element-112">
                <a href="#about" className="text-gray-400 hover:text-white transition-colors" data-id="element-113">
                  About Us
                </a>
              </li>
              <li data-id="element-114">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-115">
                  Services
                </a>
              </li>
              <li data-id="element-116">
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors" data-id="element-117">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-118">
            <h3 className="text-lg font-semibold mb-6" data-id="element-119">Services</h3>
            <ul className="space-y-3" data-id="element-120">
              <li data-id="element-121">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-122">
                  Web Development
                </a>
              </li>
              <li data-id="element-123">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-124">
                  Mobile Apps
                </a>
              </li>
              <li data-id="element-125">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-126">
                  UI/UX Design
                </a>
              </li>
              <li data-id="element-127">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-128">
                  Custom Software
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-129">
            <h3 className="text-lg font-semibold mb-6" data-id="element-130">Newsletter</h3>
            <p className="text-gray-400 mb-4" data-id="element-131">
              Subscribe to our newsletter for the latest updates and insights.
            </p>
            <form className="flex" data-id="element-132">
              <input type="email" placeholder="Your email" className="px-4 py-2 bg-gray-800 text-white rounded-l-lg focus:outline-none focus:ring-2 focus:ring-blue-500 border-none flex-grow" data-id="element-133" />
              <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-r-lg hover:bg-blue-700 transition-colors" data-id="element-134">
                Subscribe
              </button>
            </form>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-135">
          <p className="text-gray-400 text-sm mb-4 md:mb-0" data-id="element-136">
            &copy; {new Date().getFullYear()} Swedenmark Studio. All rights
            reserved.
          </p>
          <div className="flex space-x-6 text-sm text-gray-400" data-id="element-137">
            <a href="#" className="hover:text-white transition-colors" data-id="element-138">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-139">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-140">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}